import axios from 'axios'
import { useStateValue } from "./StateProvider";
import { actionTypes } from "./reducer";
import { useHistory } from "react-router-dom";
import appConfig from "./config/appConfig.js";


let REACT_APP_AUTH_KEY = process.env.REACT_APP_AUTH_KEY;
/* console.log("REACT_APP_AUTH_KEY:",REACT_APP_AUTH_KEY) */
/* let API_URL = appConfig?.API_URL; */

class Config {
    static API_URL = window.API_URL;
    static API_NAME = window.API_NAME;
    static AUTH_KEY = window.AUTH_KEY;
}

let apiURL = Config.API_URL;
let apiAuthKey = Config.AUTH_KEY;

/* if(API_URL != apiURL){
    apiURL = API_URL;
} */

//DEV LOCAL
//apiURL = "http://127.0.0.1:8000/";


const instance = axios.create({
    baseURL: apiURL,
    headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAuthKey}`,
        }
});

instance.interceptors.response.use(
    (response) =>
    new Promise((resolve, reject) => {
        resolve(response);
    }),
    (error) => {
        const originalRequest = error.config;
        if (!error.response){
            return new Promise(
                (resolve , reject) => {
                    reject(error);
                });
        }

        if (error.response.status === 401 && !originalRequest._retry){

            originalRequest._retry = true;
            return instance.post('/refresh-token/',
                {
                  "RefreshToken": localStorage.getItem("RefreshToken")
                })
                .then(res => {
                    if (res.status === 200) {

                        console.log(res.data);

                        localStorage.setItem("AuthToken", res.data.AuthToken);
                        localStorage.setItem("RefreshToken", res.data.RefreshToken);
                        // 1) put token to LocalStorage
                        //localStorageService.setToken(res.data);
     
                        // 2) Change Authorization header
                        instance.defaults.headers.common['Auth-Token'] = res.data.AuthToken;
                        originalRequest.headers['Auth-Token'] = res.data.AuthToken;
                        // 3) return originalRequest object with Axios.
                        return instance(originalRequest);

                    }
                })
                .catch(err => {
                  if (err.response.status === 400) {
                    //DO LOGOUT THING
                    const localUser = JSON.parse(localStorage.getItem("user"));
                    console.log(localUser);
                    localStorage.setItem("user", null);
                    window.location = "/";
                  }
                });

        }
        else{
            return new Promise(
                (resolve , reject) => {
                    reject(error);
                });
        }

    }
)

export default instance
